import type { Video } from '@/api/videos/type'

export const isRegistered = (video: Video) => {
  return !!video.adType || !!video.brandId
}
